export default __webpack_public_path__ + "static/media/song1_img.ddae1073.jpg";